<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="plant-wrapper-top-title">虫情杀虫详情</div>
      <div class="handle-wrapper" style="opacity: 0"><div class="icon-font">&#xe612;</div>返回</div>
    </div>
    <div class="plant-deal-content" v-if="loading">
      <div class="loading-data">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后···</div>
      </div>
    </div>
    <div class="plant-deal-content" v-if="!loading">
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">申请编号：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.applyNum"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">仓库位置：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.siteName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">负责人员：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.principalName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">制单人员：</div>
          <div class="input-wrapper" style="margin-right: 0">
            <input disabled="true" v-model="inputValue.createdUser"/>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">制单日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.createdTime"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">杀虫日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.killPestTime"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">完成日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.finishTime"/>
          </div>
        </div>
        <div class="input-contain" style="opacity: 0">
          <div class="input-title">完成日期：</div>
          <div class="input-wrapper" style="margin-right: 0"></div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div>杀虫方式：</div>
          <div class="text-wrapper">
            {{inputValue.killPestType}}
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">审核人员：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.approverName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">审核日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.approverTime"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">处理人员：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.handlerName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">处理日期：</div>
          <div class="input-wrapper" style="margin-right: 0">
            <input disabled="true" v-model="inputValue.handleTime"/>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-contain">
            <div class="input-title">垛位状态：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.stackStatus"/>
            </div>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div>处理情况：</div>
          <div class="text-wrapper">
            {{inputValue.handleMsg}}
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div style="padding-left: 1.8vw">备注：</div>
          <div class="text-wrapper">
            {{inputValue.remark}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {applyInfo} from '../../../api/maintain'
import {renderTime} from '../../../tools/methods'
export default {
  name: 'LookHistoryDetail',
  data () {
    return {
      loading: true,
      inputValue: {
        applyNum: '',
        finishTime: '',
        handleMsg: '',
        handleTime: '',
        handlerName: '',
        killPestTime: '',
        killPestType: '',
        principalName: '',
        siteName: '',
        stackStatus: '',
        createdUser: '',
        createdTime: '',
        approverName: '',
        approverTime: '',
        remark: ''
      }
    }
  },
  created () {
    let body = {
      pestDetailId: this.$route.query.pestDetailId,
      requestType: '03'
    }
    applyInfo(body).then(res => {
      console.log(res)
      res.data.handleTime = res.data.handleTime ? renderTime(res.data.handleTime) : '--'
      res.data.killPestTime = res.data.killPestTime ? renderTime(res.data.killPestTime) : '--'
      res.data.finishTime = res.data.finishTime ? renderTime(res.data.finishTime) : '--'
      res.data.createdTime = res.data.createdTime ? renderTime(res.data.createdTime) : '--'
      res.data.approverTime = res.data.approverTime ? renderTime(res.data.approverTime) : '--'
      this.inputValue = {
        applyNum: res.data.applyNum,
        finishTime: res.data.finishTime,
        handleMsg: res.data.handleMsg || '--',
        handleTime: res.data.handleTime,
        handlerName: res.data.handlerName || '--',
        killPestTime: res.data.killPestTime,
        killPestType: res.data.killPestType,
        principalName: res.data.principalName,
        siteName: res.data.siteName,
        createdUser: res.data.createdUser,
        createdTime: res.data.createdTime,
        approverName: res.data.approverName || '--',
        approverTime: res.data.approverTime,
        stackStatus: res.data.stackStatus === '01' ? '需杀虫' : res.data.stackStatus === '02' ? '正常养护' : '--',
        remark: res.data.remark || '--'
      }
      this.loading = false
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/LookHistoryDetail.vue